var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.errors),function(error,i){return _c('div',{key:'error-' + i,staticClass:"mt-1 text-xs text-red-600"},[_vm._v(" "+_vm._s(error)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }